var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.95657 12.0013C2.95657 7.05762 6.96418 3.05001 11.9078 3.05001C16.8514 3.05001 20.8591 7.05762 20.8591 12.0013C20.8591 16.9449 16.8514 20.9525 11.9078 20.9525C6.96418 20.9525 2.95657 16.9449 2.95657 12.0013ZM11.9078 1.45001C6.08052 1.45001 1.35657 6.17397 1.35657 12.0013C1.35657 17.8285 6.08052 22.5525 11.9078 22.5525C17.7351 22.5525 22.4591 17.8285 22.4591 12.0013C22.4591 6.17397 17.7351 1.45001 11.9078 1.45001ZM12.726 9.82589C12.726 10.2677 13.0842 10.6259 13.526 10.6259H13.7015L12.4726 11.8547L10.9315 10.3136C10.7815 10.1636 10.578 10.0793 10.3658 10.0793C10.1536 10.0793 9.95015 10.1636 9.80012 10.3136L6.99103 13.1227C6.67861 13.4351 6.67861 13.9417 6.99103 14.2541C7.30345 14.5665 7.80998 14.5665 8.1224 14.2541L10.3658 12.0107L11.9069 13.5518C12.057 13.7018 12.2605 13.7861 12.4726 13.7861C12.6848 13.7861 12.8883 13.7018 13.0383 13.5518L14.8329 11.7573V12.2838C14.8329 12.7257 15.191 13.0838 15.6329 13.0838C16.0747 13.0838 16.4329 12.7257 16.4329 12.2838V9.82589C16.4329 9.38406 16.0747 9.02589 15.6329 9.02589H13.526C13.0842 9.02589 12.726 9.38406 12.726 9.82589Z",
    fill: "#111114"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtra);
export default __webpack_public_path__ + "static/media/extra.dc3895681ec9f7b9bd2ec63d4a5dd677.svg";
export { ForwardRef as ReactComponent };